module.exports = __webpack_public_path__ + "img/Logo2x.df50065.png";